// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__jYsjF","imageUploader":"EGiftCard_imageUploader__1cYtN"};